module.exports = __webpack_public_path__ + "img/lowthuru_suwade.152788cd.jpg";